import { gql } from '@lcs/shared/api';

export const SavePresenceContactExtensionsMutation = gql`
   mutation SavePresenceContactExtension(
      $extension: ExtensionInput!
      $deletedDepartmentExtensionIds: [UInt!]!
      $hasDeletedDepartmentExtensions: Boolean = false
   ) {
      deleteDepartmentExtensions(ids: $deletedDepartmentExtensionIds) @include(if: $hasDeletedDepartmentExtensions)
      extension: saveExtension(extension: $extension) {
         extensionId
         departmentExtensionsConnection {
            items {
               departmentExtensionId
               departmentId
               extensionId
            }
         }
         extensionPhone {
            extensionPhoneId
            office
            dndStatus
         }
      }
   }
`;
